import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      d="M13.8001 9.29977V5.69977C13.8001 4.2086 12.5913 2.99977 11.1001 2.99977L7.50011 11.0998V20.9999H17.9581C18.8557 21.0099 19.6235 20.3572 19.7581 19.4698L21.0001 11.3698C21.0794 10.8476 20.9253 10.317 20.5788 9.91853C20.2323 9.52002 19.7282 9.29379 19.2001 9.29977H13.8001Z"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9543 21.7499H7.50011C7.08589 21.7499 6.75011 21.4141 6.75011 20.9999V11.0998C6.75011 10.9948 6.77213 10.8911 6.81475 10.7952L10.4147 2.69517C10.5351 2.42432 10.8037 2.24977 11.1001 2.24977C13.0055 2.24977 14.5501 3.79439 14.5501 5.69977V8.54977H19.1962C19.9426 8.54265 20.6548 8.86298 21.1447 9.4264C21.6357 9.99096 21.8539 10.7426 21.7416 11.4823L20.4996 19.5822C20.4996 19.5824 20.4997 19.582 20.4996 19.5822C20.3089 20.8377 19.2236 21.7618 17.9543 21.7499ZM17.9665 20.2499C18.4902 20.2558 18.9381 19.875 19.0166 19.3573L20.2586 11.2572C20.2586 11.2571 20.2586 11.2574 20.2586 11.2572C20.3047 10.9528 20.2149 10.643 20.0128 10.4107C19.8107 10.1782 19.5166 10.0462 19.2086 10.0497L19.2001 10.0498L13.8001 10.0498C13.3859 10.0498 13.0501 9.71398 13.0501 9.29977V5.69977C13.0501 4.78229 12.4165 4.0128 11.563 3.80503L8.25011 11.2589V20.2499L17.9665 20.2499Z"
      fill="currentColor"
    />
    <path
      d="M7.5 11.0003H5.097C4.04266 10.9816 3.14135 11.855 3 12.9V19.2C3.14135 20.245 4.04266 21.0186 5.097 21H7.5V11.0003Z"
      fill="currentColor"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 12.9557C3.8662 12.2599 4.47135 11.7394 5.08374 11.7502L5.097 11.7504L6.75 11.7503V20.25H5.08374C4.42478 20.2616 3.85934 19.7893 3.75 19.1439V12.9557ZM5.10309 10.2503C3.62322 10.2281 2.44203 11.4298 2.25677 12.7994C2.25226 12.8328 2.25 12.8663 2.25 12.9V19.2C2.25 19.2336 2.25226 19.2672 2.25677 19.3005C2.44879 20.7201 3.6715 21.7717 5.10313 21.75H7.5C7.91421 21.75 8.25 21.4142 8.25 21V11.0003C8.25 10.5861 7.91421 10.2503 7.5 10.2503H5.10309Z"
      fill="currentColor"
    />
  </svg>
);
